import { takeLatest, put, call } from 'redux-saga/effects';
import { history } from '@commons';
import { createFornecedorCadastro, updateFornecedorCadastro } from '../service';
import {
  CREATE_FORNECEDOR_CADASTRO,
  CREATE_FORNECEDOR_CADASTRO_PENDING,
  CREATE_FORNECEDOR_CADASTRO_SUCCESS,
  CREATE_FORNECEDOR_CADASTRO_FAILURE,
} from '@handler';
import { AlertSuccess, AlertError } from '@components/common/AlertToast';
import { formatJsonRemoveEmptyOrNull } from '@components/common/format';
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaCreateFornecedorCadastro(action) {
  yield put({ type: CREATE_FORNECEDOR_CADASTRO_PENDING });

  try {
    let type = '';
    if (action.data.tipoPessoa === 'FISICA') {
      type = 'PessoaFisica';
      if (action.data.indicadorInscrEstadual === null || action.data.indicadorInscrEstadual === undefined || action.data.indicadorInscrEstadual === '') {
        action.data.indicadorInscrEstadual = 'NAOCONTRIBUINTE';
      }
      if (action.data.indicadorInscrEstadual === 'CONTRIBUINTEISENTO'){
        action.data.inscricaoEstadual = null;
      }
    } else {
      type = 'PessoaJuridica';
      if (action.data.indicadorInscrEstadual === null || action.data.indicadorInscrEstadual === undefined || action.data.indicadorInscrEstadual === '') {
        action.data.indicadorInscrEstadual = 'CONTRIBUINTEISENTO';
      }
      if (action.data.indicadorInscrEstadual === 'NAOCONTRIBUINTE' || action.data.indicadorInscrEstadual === 'CONTRIBUINTEISENTO'){
        action.data.inscricaoEstadual = null;
      }
    }
    
    if (action.data.id === undefined || action.data.id === null) {
      yield call(createFornecedorCadastro, formatJsonRemoveEmptyOrNull({
        ...action.data,
        type: type
      }));
      trackingEventCX('action', MODULE_ACTIONS_ENUM.FORNECEDOR_CRIAR);
    } else {
      yield call(updateFornecedorCadastro,
        {
          ...action.data,
          id: action.data.id,
          type: type
        }
      );
      trackingEventCX('action', MODULE_ACTIONS_ENUM.FORNECEDOR_EDITAR);
    }

    yield put({ type: CREATE_FORNECEDOR_CADASTRO_SUCCESS, registro: action.data });

    if(!action.isCadastroRapido){
      history.push('/fornecedorCadastro');
    }

    AlertSuccess('Registro salvo com sucesso!');
  } catch (error) {
    yield put({ type: CREATE_FORNECEDOR_CADASTRO_FAILURE, registro: action.data });
    AlertError('Falha ao salvar o registro! Tente novamente...');
  }
}

export default function* watchCreateFornecedorCadastro() {
  yield takeLatest(CREATE_FORNECEDOR_CADASTRO, sagaCreateFornecedorCadastro);
}
